import { AvatarNew, HelpIcon, Icon, PillBadge } from '@platform/components';
import { LinkedInLink } from './InfoCard';

export const UserCard = ({
  avatarUrl,
  name,
  title,
  location,
  languages,
  linkedInAccount,
  isProjectLead,
}: {
  avatarUrl: string;
  name: string;
  title: string;
  location?: string;
  languages: string[];
  linkedInAccount?: LinkedInLink;
  isProjectLead?: boolean;
}) => {
  return (
    <div className='min-w-60  relative bg-gray-50 px-6 py-8 flex flex-col gap-2 items-center text-center'>
      <div className='w-24 h-24'>
        <AvatarNew url={avatarUrl} alt={`${name}'s avatar`} fallbackIcon='user-01' />
      </div>
      {isProjectLead && (
        <div className='absolute top-4 left-2'>
          <PillBadge color='success-25' size='sm' variant='plain'>
            Project lead
          </PillBadge>
        </div>
      )}
      <div className='flex flex-col items-center '>
        <span className='text-lg font-semibold text-gray-700'>{name}</span>
        <span className='text-md font-medium text-gray-700'>{title}</span>
      </div>
      {location && (
        <div className='text-base text-gray-400 inline-flex items-center gap-1'>
          <span className='inline-flex gap-1 text-gray-400'>
            <span className='mt-0.5'>
              <Icon type='marker-pin-01' size='18' />
            </span>
            {location}
          </span>
        </div>
      )}
      <span className='text-base text-gray-400'>
        {languages.length > 2 && (
          <>
            Speaks {languages[0]}, {languages[1]}...{' '}
            <HelpIcon
              supportingText={`Speaks ${languages.slice(0, -1).join(', ')} and ${languages[languages.length - 1]}`}
            />
          </>
        )}
        {languages.length <= 2 && (
          <>Speaks {languages.length === 0 ? 'English' : languages.join(', ')}</>
        )}
      </span>
      <a
        className='pt-2 mt-auto text-[#0a66c2]'
        target='_blank'
        href={`https://www.linkedin.com/in/${linkedInAccount}`}
      >
        <Icon type='linked-in' size='32' viewbox='0 0 32 32' />
      </a>
    </div>
  );
};
